export default __webpack_public_path__ + "static/googlePlay-0672864aaf24b63f921a2b7bdfbf6d78.svg";